import { Divider, DividerProps } from 'antd';

export const HistoryDivider = (props: DividerProps) => {
  return (
    <Divider
      {...props}
      className="!text-[12px] !my-2 !mx-auto !text-content-200 [&_.ant-divider-inner-text]:!text-content-200"
    />
  );
};
